module.exports = __webpack_public_path__ + "static/media/contract.5a3323b1.svg";